import { connect } from 'react-redux';
import { withTranslation } from '@wix/wix-i18n-config';
import { withRouter } from 'react-router-dom';
import { withLogoServices } from '@wix/branding-client-lib/dist/src/services/LogoServicesProvider';
import { withDataFetcher } from '../../universal/dataFetcherContext';
import { withExperiments } from '@wix/wix-experiments-react';

export function createController(Component, mapStateToProps, mapDispatchToProps, shouldFetch = false) {
  return withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(withTranslation()(withExperiments(withLogoServices(withDataFetcher(Component, shouldFetch)))))
  );
}
